module.exports = __webpack_public_path__ + "45861ae281fb110f73eabbd462fc852a.MP3";